import { Link } from 'react-router-dom';
import { useIncomeClear } from '../hooks/ClearIncome';
import AnimatedBackground from '../../utils/AnimatedBackground';
import TopBar from '../../utils/TopBar';
import Footer from '../../utils/Footer';

const ClearIncome = () => {
  const { isConfirmed, handleConfirmChange, handleSubmit } = useIncomeClear();

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col relative">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <header className="bg-black shadow-lg border-b border-gray-800 relative z-10">
          <TopBar 
            title="Clear All Income"
            subtitle="Permanently delete all income records"
          />
        </header>
        <main className="flex-grow flex items-center justify-center py-12 relative z-10">
          <div className="w-full max-w-2xl mx-auto">
            <div className="bg-black border border-gray-700 shadow-lg rounded-lg mx-4">
              <div className="p-8">
                <h2 className="text-2xl font-medium text-white text-center mb-6">Clear All Income</h2>
                <div className="text-lg text-gray-300 text-center mb-8">
                  <p>Are you sure you want to clear all income? All your data will be lost forever.</p>
                  <p className="mt-3">This action cannot be undone.</p>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="flex items-center justify-center mb-8">
                    <input
                      id="confirm-clear"
                      name="confirm-clear"
                      type="checkbox"
                      className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-800 rounded"
                      onChange={handleConfirmChange}
                    />
                    <label htmlFor="confirm-clear" className="ml-3 text-lg text-gray-300">
                      I understand and want to proceed
                    </label>
                  </div>
                  <div className="flex justify-center space-x-4">
                    <Link
                      to="/income/dashboard"
                      className="px-4 py-2 border border-transparent rounded-md text-base font-medium text-white bg-blue-600 hover:bg-blue-500"
                    >
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      disabled={!isConfirmed}
                      className={`px-4 py-2 border border-transparent rounded-md text-base font-medium text-white ${
                        isConfirmed
                          ? 'bg-red-600 hover:bg-red-500'
                          : 'bg-gray-600 cursor-not-allowed'
                      }`}
                    >
                      Clear All Income Data
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default ClearIncome;

